// Link rastreável de indicação (?ref=CODE) -- 12/07/2026, a pedido do Thales
// ("to com site do delivery pronto, queria dar um link rastreavel pra cada
// um"). Cobre funcionário interno e parceiro externo, ambos usando o mesmo
// mecanismo de link no site.
//
// Como funciona: quem divulga o link manda algo como
// autodelivery.app.br/{slug}?ref=CODIGO. Ao abrir, guardamos o código no
// localStorage (por loja, porque o domínio é compartilhado entre tenants)
// pra sobreviver à navegação entre a vitrine, a página de produto e o
// checkout -- mesmo que o cliente não finalize o pedido na mesma visita.
// Nunca bloqueia nada: código ausente/inválido/expirado só significa que
// ninguém recebe comissão por aquele pedido (o backend decide isso).

const storageKey = (slug: string) => `autocobranca_ref_${slug}`;

/** Chamar uma vez ao carregar qualquer página do site (App.tsx). */
export function captureReferralFromUrl(slug: string | undefined): void {
  if (!slug) return;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref || !ref.trim()) return;
    localStorage.setItem(storageKey(slug), ref.trim().toUpperCase());
  } catch {
    // localStorage indisponível (aba anônima muito restrita etc.) -- sem
    // problema, o pedido só não terá referralCode.
  }
}

/** Chamar na hora de montar o payload de criação do pedido. */
export function getStoredReferralCode(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  try {
    return localStorage.getItem(storageKey(slug)) ?? undefined;
  } catch {
    return undefined;
  }
}
